import PageHeader from './PageHeader'

export default PageHeader



// WEBPACK FOOTER //
// ./src/components/shared/PageHeader/index.js